const FormatPriceVerbal = (price) => {
  if (price < 1000) return price;
  /**
   * @returns Foramtted Price in String
   */
  price = parseInt(price);
  const Crore = (price / 10000000) * 1;
  const Lac = (price / 100000) * 1;
  const Thousand = (price / 1000) * 1;
  return Crore >= 1
    ? `${Crore.toFixed(2)} Crore`
    : Lac >= 1
    ? `${Lac.toFixed(2)} Lac`
    : Thousand >= 1
    ? `${Thousand.toFixed(2)} Thousand`
    : "";
};

export default FormatPriceVerbal;
